import { createAcceptanceModalDialogProps } from "./createAcceptanceModalDialogProps";
import { ModalDialog } from "./ModalDialog";
import type { AcceptanceDialogProps } from "./types";

export const AcceptanceDialog = ({
  open,
  header,
  message,
  confirmLabel,
  onConfirm,
  onClose,
  ...props
}: AcceptanceDialogProps) => {
  const acceptanceDialogProps = createAcceptanceModalDialogProps({ header, message, confirmLabel, onConfirm });

  return <ModalDialog {...props} open={open} onClose={onClose} {...acceptanceDialogProps} />;
};
